(() => {
  const isCustomVariant = (variant) => {
    const title = String(variant?.title || '');
    const parts = title.split(' / ');
    if (parts.some((part) => part.trim().toLowerCase() === 'custom')) return true;
    const options = Array.isArray(variant?.options) ? variant.options : [];
    return options.some((option) => String(option).trim().toLowerCase() === 'custom');
  };

  const powderField = () => {
    const wrap = document.querySelector('[data-wpm-powder-color]');
    const input = wrap?.querySelector('[data-wpm-powder-input]');
    const error = wrap?.querySelector('[data-wpm-powder-error]');
    return { wrap, input, error };
  };

  const setPowderError = (on) => {
    const { input, error } = powderField();
    if (!input || !error) return;
    input.classList.toggle('is-invalid', on);
    input.setAttribute('aria-invalid', on ? 'true' : 'false');
    error.hidden = !on;
    if (on) {
      error.textContent = 'Please enter a Prismatic color name before adding to cart.';
      input.focus();
    }
  };

  const syncPowderField = (variant) => {
    const { wrap, input } = powderField();
    if (!wrap || !input) return;
    const custom = isCustomVariant(variant);
    wrap.hidden = !custom;
    input.disabled = !custom;
    input.required = custom;
    if (!custom) {
      input.value = '';
      setPowderError(false);
    }
  };

  const openFinishFaq = () => {
    const finish = document.getElementById('finish-options');
    if (finish?.tagName === 'DETAILS') finish.open = true;
  };

  const specDrawer = document.querySelector('[data-wpm-specs-drawer]');
  if (specDrawer) {
    const mq = window.matchMedia('(min-width: 990px)');
    const syncSpecDrawer = () => {
      if (mq.matches) specDrawer.setAttribute('open', '');
      else specDrawer.removeAttribute('open');
    };
    syncSpecDrawer();
    if (mq.addEventListener) mq.addEventListener('change', syncSpecDrawer);
    else mq.addListener(syncSpecDrawer);
  }

  if (location.hash === '#finish-options') openFinishFaq();

  document.querySelectorAll('a[href="#finish-options"]').forEach((link) => {
    link.addEventListener('click', () => {
      openFinishFaq();
    });
  });

  const { input: powderInput } = powderField();
  powderInput?.addEventListener('input', () => {
    if (powderInput.value.trim()) setPowderError(false);
  });

  const productForm = document.querySelector('[data-type="add-to-cart-form"]');
  productForm?.addEventListener(
    'submit',
    (evt) => {
      const { wrap, input } = powderField();
      if (!wrap || wrap.hidden || !input || input.disabled) return;
      if (input.value.trim()) {
        setPowderError(false);
        return;
      }
      evt.preventDefault();
      evt.stopImmediatePropagation();
      setPowderError(true);
    },
    true
  );

  const gallery = document.querySelector('[data-wpm-pdp-gallery]');
  if (gallery) {
    const stageImg = gallery.querySelector('[data-wpm-pdp-stage]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-wpm-pdp-thumb]'));
    if (stageImg && thumbs.length) {
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const src = thumb.getAttribute('data-full-src');
          const srcset = thumb.getAttribute('data-full-srcset');
          const alt = thumb.getAttribute('data-alt') || '';
          if (!src) return;

          stageImg.setAttribute('src', src);
          if (srcset) stageImg.setAttribute('srcset', srcset);
          stageImg.setAttribute('alt', alt);

          thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
        });
      });
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event?.data?.variant;
      if (variant) syncPowderField(variant);
    });
  }

  const jsonLd = document.querySelector('script[id^="WpmProductJsonLd-"]');
  if (!jsonLd || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  // Keep Product + single Offer aligned with the selected variant (Google merchant listing).
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variant = event?.data?.variant;
    if (!variant?.id) return;

    let data;
    try {
      data = JSON.parse(jsonLd.textContent);
    } catch (error) {
      return;
    }

    const offerUrl = `${window.location.origin}${window.location.pathname}?variant=${variant.id}`;
    const cents = Number(variant.price);
    const price = Number.isNaN(cents) ? undefined : Number((cents / 100).toFixed(2));

    const existing = Array.isArray(data.offers) ? data.offers[0] : data.offers;
    const offer = {
      ...(existing && typeof existing === 'object' ? existing : {}),
      '@type': 'Offer',
      url: offerUrl,
      priceCurrency: existing?.priceCurrency || 'USD',
      availability: variant.available ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
      itemCondition: existing?.itemCondition || 'https://schema.org/NewCondition',
    };

    if (price !== undefined) offer.price = price;
    if (variant.title && variant.title !== 'Default Title') {
      offer.name = variant.title;
    } else {
      delete offer.name;
    }
    if (variant.sku) {
      offer.sku = variant.sku;
      data.sku = variant.sku;
    } else {
      delete offer.sku;
      delete data.sku;
    }

    data.url = offerUrl;
    data.offers = offer;
    jsonLd.textContent = JSON.stringify(data);
  });
})();
